
import { AfterViewInit, Component, ElementRef, ViewChild, Input } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';

declare var google: any;

@Component({
    selector: 'app-pie-chart-dispute-ratio',
    template: `<div #pieChart style="width: 100%; height: 100%;"></div>`
})
export class PieChartDisputeRatioComponent implements AfterViewInit {

    @ViewChild('pieChart') pieChart: ElementRef

    yr: any;

    @Input() set countDispute(countDispute: number) {
        this.yr = countDispute;
        const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
        const options = {
            legend: { position: 'top' },
            //pieSliceText: 'value',
        };
        var getTopTenEmployerResponse3 : any;
        this.dashboardService.getDisputeRatio(this.yr)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getDisputeRatio response---", data)
                    getTopTenEmployerResponse3 = data.respData;

                    var datad = new google.visualization.DataTable();
                    datad.addColumn('string', 'Month');
                    datad.addColumn('number', 'Count');


                    datad.addRow(['Open', getTopTenEmployerResponse3.Open]);
                    datad.addRow(['Clear', getTopTenEmployerResponse3.Clear]);

                    // var chartdata = new google.visualization.arrayToDataTable(data1);
                    chart.draw(datad, options);
                },
                error => {
                    console.log(error)
                }
            )
    }

     
    constructor(private dashboardService: DashboardService) { }
    currentyear =(new Date()).getFullYear();
    chartdata: any;
    // getTopTenEmployerResponse: any;
    result = [];
    drawChart = () => {
        let datatbl = google.visualization.arrayToDataTable([
            ['Task', 'Hours per Day'],
        ]);
        var getTopTenEmployerResponse4 : any;
        this.dashboardService.getDisputeRatio(this.currentyear)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getDisputeRatio response---", data)
                    getTopTenEmployerResponse4 = data.respData;
                    var datad = new google.visualization.DataTable();
                    datad.addColumn('string', 'Month');
                    datad.addColumn('number', 'Count');
                    datad.addRow(['Open', getTopTenEmployerResponse4.Open]);
                    datad.addRow(['Clear', getTopTenEmployerResponse4.Clear]);
                    chart.draw(datad, options);
                },
                error => {
                    console.log(error)
                })
        const options = {
            legend: { position: 'top' },
           // pieSliceText: 'value',
        };

        const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
    }

    ngAfterViewInit() {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(this.drawChart);
    }
}